// Resolves the correct store link + i18n text key for installing the rubra
// extension (desktop browsers) or app (mobile), based on the user's browser/OS
// and viewport. Shared by the AddBookmark view and the extension-install banner.

// Order matters: matched against the lowercased browser name (Bowser output).
const DESKTOP_BROWSERS = [
  { match: 'chrome', key: 'chrome' },
  { match: 'firefox', key: 'firefox' },
  { match: 'edge', key: 'edge' },
  { match: 'safari', key: 'safari' },
]

const INSTALL_BTN_I18N_PREFIX = 'page.bookmarks.install_btn'

/**
 * @param {Object} opts
 * @param {string|null} opts.browser - Bowser-detected browser name
 * @param {string|null} opts.os - device OS ('ios' | 'android' | ...)
 * @param {boolean} opts.isDesktop
 * @param {boolean} opts.isMobile
 * @returns {{ url: string, text: string } | null} store link + i18n key, or null
 *          when there is no installable target for the current browser/OS.
 */
export function resolveInstallLink({ browser, os, isDesktop, isMobile }) {
  const links = CONFIG.storeLinks

  if (isDesktop && browser) {
    const name = browser.toLowerCase()
    const found = DESKTOP_BROWSERS.find(b => name.includes(b.match))
    if (found) return { url: links[found.key], text: `${INSTALL_BTN_I18N_PREFIX}.${found.key}` }
  }

  if (isMobile) {
    if (os === 'ios') return { url: links.ios, text: `${INSTALL_BTN_I18N_PREFIX}.ios` }
    if (os === 'android') return { url: links.android, text: `${INSTALL_BTN_I18N_PREFIX}.android` }
  }

  return null
}
